import Vue from 'vue';

// 按钮
import {Swipe, SwipeItem, List ,Calendar , Button, Divider, Icon, Cell, CellGroup, Field, Toast, DropdownMenu, DropdownItem, Image as VanImage, ActionSheet, Checkbox, CheckboxGroup, Tabbar, TabbarItem, Step, Steps, DatetimePicker } from 'vant'
Vue.use(Button)
Vue.use(Divider)
Vue.use(Icon)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Field)
Vue.use(Toast)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(VanImage)
Vue.use(ActionSheet)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Step)
Vue.use(Steps)
Vue.use(DatetimePicker)
Vue.use(Calendar)
Vue.use(List)
Vue.use(Swipe)
Vue.use(SwipeItem)
// Layout布局
import { Col, Row } from 'vant';
Vue.use(Col).use(Row);


// 弹框层
import { Popup } from 'vant';
Vue.use(Popup);

// picker
import { Picker } from 'vant';
Vue.use(Picker);

// Uploader 文件上传
import { Uploader } from 'vant';
Vue.use(Uploader);

// Area 省市区选择
import { Area } from 'vant';
Vue.use(Area);

// Radio 单选框
import { RadioGroup, Radio } from 'vant';
Vue.use(Radio);
Vue.use(RadioGroup);

// Empty 空状态
import { Empty } from 'vant';
Vue.use(Empty);

// Loading 加载
import { Loading } from 'vant';
Vue.use(Loading);

// Overlay 遮罩层
import { Overlay } from 'vant';
Vue.use(Overlay);
// // 1. 底部的导航
// import { Tabbar, TabbarItem } from 'vant';
// Vue.use(Tabbar).use(TabbarItem);
//
// // 2. Loading
// import { Loading } from 'vant';
// Vue.use(Loading);
//
// //3. 图片懒加载
// import { Image } from 'vant';
// Vue.use(Image);
//
// // 4. 提示
// import { Toast } from 'vant';
// Vue.use(Toast);
//
// // 5. 蒙版提示
// import { Dialog } from 'vant';
// Vue.use(Dialog);
//
// // 6. 导航栏
// import { NavBar } from 'vant';
// Vue.use(NavBar);
//
// // 7. 地址
// import { ContactCard, ContactList, ContactEdit } from 'vant';
// Vue.use(ContactCard).use(ContactList).use(ContactEdit);
//
// import { AddressList } from 'vant';
// Vue.use(AddressList);
//
// import { AddressEdit } from 'vant';
// Vue.use(AddressEdit);
//
// // 8. 单元格
//
// // 9. 提交订单
// import { SubmitBar } from 'vant';
// Vue.use(SubmitBar);
//
// // 10. 宫格
// import { Grid, GridItem } from 'vant';
// Vue.use(Grid).use(GridItem);
//
// // 11. 弹出层
// import { Popup } from 'vant';
// Vue.use(Popup);
//
// // 12. 日期组件
// import { DatetimePicker } from 'vant';
// Vue.use(DatetimePicker);
//
// // 13. 卡片选项
// import { Card } from 'vant';
// Vue.use(Card);
//
// // 14. 选项卡
import { Tab, Tabs } from 'vant';
Vue.use(Tab).use(Tabs);

// 表单
import { Form } from 'vant';
Vue.use(Form);

// 地区选则
import { Cascader } from 'vant';
Vue.use(Cascader);



// WEBPACK FOOTER //
// ./src/common/vant.js